import React from 'react';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import Carousel from 'components/Carousel';
import CalculatorCard from '../CalculatorCard/CalculatorCard';
import s from './CalculatorList.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

const CalculatorList = ({
  items,
  name,
  isWapView = true,
  isArticleshowPage = false,
  ga4Type = '',
  ga4Category = '',
}) => {
  let gaCategory;

  if (!isArticleshowPage) {
    gaCategory = `${isWapView ? 'WAP' : 'WEB'}-CL-finance-calculator_${
      name?.split(' ')[0]
    }`;
  } else {
    gaCategory = `${isWapView ? 'mWEB' : 'WEB'}-articleshowv2`;
  }

  const onView = () => {
    analyticsWrapper('ga4', {
      event: 'user_shown',
      type: `other_financial_calculator`,
    });
  };
  return (
    // <ElementInView
    // // gaCategory={gaCategory}
    // // gaLabel={
    // //   isArticleshowPage
    // //     ? 'financial-calculator_view'
    // //     : 'other_calculator_view'
    // // }
    // // gaAction="scroll_measure"
    // >
    <InViewObserver inViewCallback={onView}>
      {items && Array.isArray(items) && items.length > 1 ? (
        <div className={s.other_calc_container}>
          <h2>Financial calculators</h2>
          {isWapView ? (
            <div className={`${s.other_calc_wrap} other_calc_wrap`}>
              {items.map(item => (
                <div className={s.card_container}>
                  <CalculatorCard
                    {...item}
                    gaCategory={gaCategory}
                    isArticleshowPage={isArticleshowPage}
                    ga4Type={ga4Type}
                    ga4Category={ga4Category}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="other_calc_rhs slick_UI">
              <Carousel
                slidesToScroll={1}
                slidesToShow={1}
                autoplay
                autoplaySpeed={5000}
              >
                {items.map(item => (
                  <div className={s.card_container}>
                    <CalculatorCard
                      {...item}
                      gaCategory={gaCategory}
                      isArticleshowPage={isArticleshowPage}
                      ga4Type={ga4Type}
                      ga4Category={ga4Category}
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          )}
        </div>
      ) : null}
    </InViewObserver>
    // </ElementInView>
  );
};

export default CalculatorList;
